import UserPlan from '@creditflowresearch/user-plan/UserPlan';
import { UserPlanFeature } from '@creditflowresearch/user-plan/vo/IUserPlanResponse';
import { EmeaRegion } from '@/creditflowresearch/domain/Region';
import { CorporateProduct } from '@/creditflowresearch/domain/Product';
import { IUserPlanState } from '@/creditflowresearch/application/User/UserPlan/types/IUserPlanState';
import { checkAccessByFeature } from './checkAccessByFeature';
import { ISSUER_AND_PARENT_PROFILE_PATTERNS, matchByPagePath } from './grants/pagePatterns';

interface IFilterIds {
  productIds: string[],
  regionIds: string[],
}

// TODO: remove when the European market opening period ends
export const isProfileLockedWithoutAddOn = (
  pathname: string,
  { plan, features }: Pick<IUserPlanState, 'plan' | 'features'>,
  { productIds, regionIds }: IFilterIds,
): boolean => {
  if (!matchByPagePath(...ISSUER_AND_PARENT_PROFILE_PATTERNS)({ pathname })) {
    return false;
  }

  const hasAddOn = checkAccessByFeature(features, UserPlanFeature.CommentaryAndDealFlow);

  if (!UserPlan.isSatisfiedPremiumPlan(plan) || hasAddOn) {
    return false;
  }

  const isEmeaCorporateRequest = regionIds.includes(EmeaRegion.REGION_ID)
    && productIds.some((productId) => CorporateProduct.CORPORATE_PRODUCT_IDS.includes(productId));

  return !isEmeaCorporateRequest;
};
